import React, { useEffect } from 'react'
import NoResultsContainer from '../NoResults/NoResults'
import { useByStudent } from '../ByStudentContext/ByStudentContext'
import Loading from '../../../../../Loading/Loading'
import GranularStepsPreview from '../GranularStepsPreview/GranularStepsPreview'
import { useSelector } from 'react-redux'

const LearningMatrix = () => {
  const { studentSelected, currentCurriculum, curriculumId, onLoadLearningMatrix, loading, learningMatrix } =
    useByStudent()
  const state = useSelector((state) => state?.filter?.learningMatrix || {})

  useEffect(() => {
    if (curriculumId && studentSelected) {
      onLoadLearningMatrix(curriculumId, studentSelected, state.filter)
    }
  }, [curriculumId, studentSelected, state.filter])

  return (
    <div className='absolute inset-0'>
      {loading ? (
        <Loading />
      ) : learningMatrix?.lcs?.length > 0 ? (
        <GranularStepsPreview
          lcs={learningMatrix.lcs}
          completed={'completedTeacher'}
          currentCurriculum={currentCurriculum || {}}
        />
      ) : (
        <NoResultsContainer />
      )}
    </div>
  )
}

export default LearningMatrix
